import React from 'react';
import { DAFSchedule } from './components/DAFSchedule/DAFSchedule';
import { FundingSourceSelect } from '../FundingSourceSelect/FundingSourceSelect';

export const Donations = () => {
  return (
    <>
      <DAFSchedule fieldNamespace="DAFContributionSchedule" />

      <FundingSourceSelect />

      <DAFSchedule fieldNamespace="DAFGrantSchedule" />
    </>
  );
};
